import styled from 'styled-components'
import { Flex, Typography } from 'antd'
import { mediaMax } from '@/app/styles/breakpoints'
import { DarkButton } from '@/shared/ui/components/Button'

const { Text } = Typography

export const TaskHeader = styled(Flex)``

export const Content = styled(Flex)`
  .ant-progress {
    width: auto;
    display: flex;
    .ant-progress-outer {
      width: 100px !important;
    }
  }

  .ant-progress-line.ant-progress-small .ant-progress-bg {
    height: 4px !important;
  }

  .ant-progress-line .ant-progress-bg {
    height: 6px !important;
  }
`

export const TaskData = styled(Flex)`
  flex: 1;
  min-width: 0;
  width: 100%;
`

export const TaskDates = styled(Flex)``

export const ProgressSection = styled(Flex)``

export const StatsCard = styled(Flex)`
  border-radius: 6px;
  width: clamp(412px, 26%, 460px);
  padding: 16px;
  background-color: ${(props) => props.theme.colors.grayBackground};
  ${mediaMax.md} {
    width: 100%;
  }
  ${mediaMax.sm} {
    padding: 8px;
  }
`

export const ProgressRow = styled(Flex)``

export const ProgressLabel = styled(Text)`
  width: 118px;
  ${mediaMax.sm} {
    width: 104px;
  }
`

export const ProgressValue = styled(Text)``

export const DownloadBtn = styled(DarkButton)`
  align-self: start;
  height: 28px;
  margin-bottom: 8px;
  ${mediaMax.sm} {
    align-self: normal;
  }
`
